
import React, { useState } from 'react';
import { Button, Input, message, Steps, theme } from 'antd';

import '../../build.css'
import Buildtable from '../Buildtable';



 const Sop5=() =>{
  const { token } = theme.useToken();
  const [current, setCurrent] = useState(0);
  const [inputValue, setInputValue] = useState(''); // State for the input value

  const next = () => {
    setCurrent(current + 1);
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const steps = [  
    
    {
      title: 'Introduction',
      content: <>
      <div   style={{marginTop:'2rem',}}>
      <Buildtable />
      <h6 id="profile">STATEMENT OF PURPOSE</h6>
      <p style={{ marginTop: "1rem" }}>
      In the scenario where you have a background in mechanical engineering and professional experience in the mechanical field but are looking to transition to a master's in Computer Science and Engineering (CSE), it's crucial to effectively communicate your motivations, relevant skills, and how your unique background enhances your candidacy.
                </p>


           
                 <p> <strong>Why this Course - Key Emphasis Section</strong> </p>
                 <p></p>
                <br></br>
                <h6>Introduction: </h6>
                <p>In the introduction, you want to grab the reader's attention by clearly stating the academic field you are passionate about. Rather than beginning with personal details, dive into the subject matter. Explain what aspects of this field interest you and why. This could include specific experiences, classes, or personal moments that sparked your interest. Convey your enthusiasm for the subject and provide a brief glimpse into what you hope to achieve within this domain.</p>
                <p>
                  <strong >Mistakes that need to be taken care of:</strong> 
                  <br></br>
                  <strong>Avoid Ambiguity:</strong> Clearly articulate why this field captures your interest. Vague statements may leave the reader unsure about your genuine passion.
                 <p> <strong>Steer Clear of Clichés:</strong>  Be original in expressing your interest. Avoid clichés that might make your introduction sound generic.</p>
                </p>
                <br></br>
                


                <hr></hr>
              
       
        </div></>,
    },
    {
      title: 'background',
      content: <>
  <div className='martop'  > <p>
                  <strong>Background:-</strong> 
                  This section is an opportunity to showcase your academic and, if applicable, professional journey. Detail your academic achievements, focusing on relevant courses or projects that have prepared you for the desired program. If you have work experience, highlight how it has contributed to your skills and knowledge. In the case of extracurricular activities, emphasize those that demonstrate skills applicable to the academic and professional world.
                
                </p>
               <p><strong>Mistakes that need to be taken care of:</strong>
                </p>
              <p><strong>Irrelevant Details</strong></p>
                <p>While providing your background, stay focused on elements that directly contribute to your suitability for the program. Avoid unnecessary details.</p>
                <h6> <strong>Overemphasis on Grades:</strong></h6>
                <p> While academic achievements are important, balance the discussion with other aspects of your background to present a holistic picture.</p>
               

     
                
                {/* <hr></hr> */}

                <hr></hr></div> </>,
    },
    {
        title: 'Course',
        content: <>  <div class="alert alert-info martop" role="alert">
  
        <p>
          <strong>Why this Course - Key Emphasis Section: </strong>
        </p>

<p><strong>What to Include:</strong></p>
<p><strong>Motivation for Transition:</strong></p>
Clearly articulate your motivation for transitioning from mechanical engineering to CSE. Explain the factors that led to this decision, such as a growing interest, industry trends, or a desire for a new challenge.   
        <p>
        <p>  <strong>Relevant Skills from Mechanical Engineering:  </strong>      </p>  
           Highlight skills from your mechanical engineering background that are transferable to CSE. This could include problem-solving, analytical thinking, project management, or any programming skills you may have developed.

        </p>


<p><strong>Professional Experience in Mechanical Field:</strong>
Discuss your professional experience in the mechanical field. Emphasize projects, responsibilities, or achievements that showcase your adaptability, technical prowess, and any intersection with CSE concepts or technologies.
</p>
<p><strong>Self-Learning and Skill Development:</strong>
If applicable, mention any self-learning initiatives, online courses, or projects you undertook to build foundational CSE skills. This demonstrates your proactive approach to acquiring the necessary knowledge.
</p>
        <p>
        <p>  <strong>Alignment with Career Goals:  </strong>      </p>  
                  Clearly state how the master's program in CSE aligns with your career goals. Discuss specific aspects of the program, such as courses, specializations, or research opportunities, that will help you achieve your objectives in the tech industry.

        </p>    <hr></hr>

        <p>
          <strong>
          How to Pen It:

          </strong>{" "}</p>

          <p>Begin by expressing your motivation for transitioning from mechanical engineering to CSE. Clearly articulate your passion for the field and the factors that influenced your decision.</p>
          <p>Showcase skills from your mechanical engineering background that are applicable to CSE, demonstrating your ability to bring a unique perspective to the program.</p>
          <p>Discuss your professional experience in the mechanical field, emphasizing projects or responsibilities that have equipped you with valuable skills relevant to CSE. Highlight any exposure to programming or technology integration.</p>
          <p>Mention any self-learning initiatives or courses you have undertaken to prepare for the transition. Emphasize your commitment to acquiring the necessary skills independently.</p>
          <p>Conclude by summarizing how your unique background, skills, and experiences make you a strong candidate for the master's program in CSE. Express your eagerness to contribute to the program and leverage your diverse background in the tech industry.</p>
        {/* <p>
          <strong>
            
            
          Mistakes that need to be taken care of:
          </strong>{" "}
          <br></br>
         <strong>Vagueness:</strong>  Clearly define your goals, providing details about the industry, role, or projects you aim to be involved in.
        </p> */}
        <p>
          <strong>  Example: </strong>{" "}
          My journey in mechanical engineering has been characterized by a commitment to technical excellence and a passion for problem-solving. However, my professional experiences have led me to a pivotal realization—the transformative impact of technology in addressing complex challenges. Motivated by a deepening interest and a desire for a new challenge, I am now eager to transition to the dynamic field of Computer Science and Engineering. My background in mechanical engineering equips me with a strong foundation in analytical thinking, project management, and problem-solving—skills that I believe are transferable and complementary to the tech industry. During my time in the mechanical field, I actively sought opportunities to integrate technology into projects, gaining exposure to programming and automation. This shift is not merely a change in academic focus but a strategic decision to align my skills with the evolving landscape of technology. I have undertaken self-learning initiatives in [specific areas] and am excited about the prospect of leveraging these skills in the Master's program at [University]. The program's emphasis on [specific aspects of CSE] perfectly aligns with my career goals, and I am eager to contribute my unique perspective to the dynamic community at [University].
        </p>       
        <hr></hr>
        </div>
        </>,
      },
      {
        title: 'Goals',
        content: <>
        <div className='martop'></div>
          <p >
                    <strong>Career Goals : </strong>
                  </p>
                  <li>
                  Explanation: In this section, clearly outline your short-term and long-term career goals. Specify what you aim to achieve immediately after completing the course and paint a vivid picture of your aspirations for the next 10-15 years. Avoid mentioning a desire to stay in a foreign country for an extended period, as it can be perceived as a lack of commitment.
                  </li>
                <p><strong>Mistakes that need to be taken care of:</strong></p>
                <strong>Vagueness:</strong>
                <p>Clearly define your goals, providing details about the industry, role, or projects you aim to be involved in.</p>
                <p><strong>Contradictions: </strong>Ensure that your stated goals align with the course you are applying for. Consistency is crucial for credibility.</p>
        </>,
      },
      {
        title: 'Second',
        content: <>
      <p   style={{marginTop: '10px',}}><strong>Why this University:</strong>This section is your chance to show that you've done your homework on the university. Highlight specific features, resources, or faculty members that attract you. Explain how these elements align with your academic and career objectives. Convey a genuine interest in what the university offers beyond just a prestigious name.</p>
      <p><strong>Mistakes that need to be taken care of:</strong></p>
      <p><strong>Generic Praise: </strong>Avoid using generic statements about the university's reputation. Instead, focus on unique features that resonate with your goals.</p>
      <p><strong>Lack of Personalization:</strong>Ensure your reasons for choosing the university go beyond general information available on their website. Personalize your response to demonstrate a deep understanding.</p>
        Conclusion: Summarize the key points discussed in your Statement of Purpose. Reiterate your passion for the chosen field and emphasize how the course at the university is a crucial step toward achieving your goals. End on a strong note, leaving a lasting impression.
      <br></br>  <strong>Introducing New Information: </strong>The conclusion is not the place for new information. Stick to summarizing what you've already discussed.
        <br></br><strong>Lack of Confidence: </strong>  Convey confidence in your goals and how the chosen course at the university is integral to your success.
       <p><strong>Mistakes that need to be taken care of:</strong></p>    
       <p><strong>Introducing New Information: </strong>The conclusion is not the place for new information. Stick to summarizing what you've already discussed.</p>
       <p><strong>Lack of Confidence: </strong>Convey confidence in your goals and how the chosen course at the university is integral to your success.</p>
        </>,
      },
  ];

  const items = steps.map((item) => ({
    key: item.title,
    title: item.title,
  }));

  const contentStyle = {
    // lineHeight: '260px',
    // textAlign: 'center',
    // color: token.colorTextTertiary,
    // backgroundColor: token.colorFillAlter,
    // borderRadius: token.borderRadiusLG,
    // border: `1px dashed ${token.colorBorder}`,
    // marginTop: 16,
  };

  return (
    <>
      <Steps current={current} items={items} />
      <div style={contentStyle}>{steps[current].content}</div>
      <div
        style={{
          marginTop: 24,
        }}
      >
         {current > 0 && (
          <Button
            style={{
              margin: '0 8px',
            }}
            onClick={() => prev()}
          >
            Previous
          </Button>
        )}{current < steps.length - 1 && (
          <Button type="primary" onClick={() => next()}>
            Next
          </Button>
        )}
       
        {current === steps.length - 1 && (
          <Button type="primary" onClick={() => message.success(`Processing complete! Input: ${inputValue}`)}>
            Done
          </Button>
        )}
       
      </div>
    </>
  );
};

export default Sop5;
